import memoize from "lodash/memoize";

import { type QueryView, Type } from "~/models/dto";

import { type ChangeActionSpec, type GlobalChangedAction, createActionSpec } from "./GlobalChangedActionUtil";

export const QUERY_VIEWS_CHANGED = "@global/QUERY_VIEWS_CHANGED";
export type QueryViewsChanged = GlobalChangedAction<typeof QUERY_VIEWS_CHANGED, QueryView>;

/**
 * BEWARE: This constant should contain all actions, so that the right action can be created for the right node type.
 */
export const getGlobalChangedActionSpecs = memoize(
	(): Array<ChangeActionSpec> => [
		createActionSpec<QueryViewsChanged, typeof QUERY_VIEWS_CHANGED, QueryView>(
			QUERY_VIEWS_CHANGED,
			Type.QueryView,
			(state) => state.queryViews,
			(state, newMap) => ({ ...state, queryViews: newMap }),
		),
	],
);
